module.exports = __webpack_public_path__ + "img/590syd.b3850320.png";